export const contactsData = {
  email: "contact@belgoumri-kalil.com",
  phone: "+33766209632",
  address: "Montélimar ",

  sheetAPI:
    "https://script.google.com/macros/s/AKfycbzi-VBfOois8I_2_-BZyPjn_PAVKUW-Nm2OHbe1u4mdVeIvIJ0n6ijw4dK1DuDfd0PV/exec",
};
